import { Paper, Stack, Typography } from '@mui/material';

import { AppFormikTextArea } from 'shared/components/AppComponents';

interface CertificationFormProps {
  test: any;
}

const RemediationForm: React.FC<CertificationFormProps> = () => (
  <Paper variant="outlined">
    <Typography variant="h6">Remediation Information</Typography>
    <Stack direction="column" spacing={2}>
      <AppFormikTextArea
        name="verification_evidence"
        placeholder="Date, tester results, logs"
        label="Verification / Retest Evidence"
        outerLabel
        rows={4}
      />

      <AppFormikTextArea
        name="residual_risk"
        placeholder="Residual severity after mitigation"
        label="Residual Risk"
        outerLabel
        rows={4}
      />

      <AppFormikTextArea
        name="compliance_notes"
        placeholder="DPO notification sent? Regulatory filings required?"
        label="Compliance Notes"
        outerLabel
        rows={4}
      />
    </Stack>
  </Paper>
);

export default RemediationForm;
